module.exports = __webpack_public_path__ + "img/bottom-hero-section-grade.3c5eaa0f.png";